import React from 'react';
import PropTypes from 'prop-types';

const CricketPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M19.74 18.384a4.953 4.953 0 0 0-4.951 4.95 4.953 4.953 0 0 0 4.951 4.952 4.953 4.953 0 0 0 4.951-4.951 4.953 4.953 0 0 0-4.951-4.951zm0 1.356c1.27 0 2.386.662 3.027 1.659-1.838 2.855-4.816 3.419-6.205 3.615a3.592 3.592 0 0 1 3.178-5.274zm0 7.19a3.58 3.58 0 0 1-2.496-1.01c4.106-.902 5.458-2.793 5.936-3.623a3.595 3.595 0 0 1-3.44 4.633zm8.93-22.89a.901.901 0 0 1-1.14 1.393l-.4-.322a1.812 1.812 0 0 1-.233.388l-5.396 6.634.698.568c.772.63.89 1.761.262 2.533l-1.855 2.284a6.068 6.068 0 0 0-2.541.274l2.435-3a.901.901 0 0 0-.13-1.266l-2.795-2.27a.901.901 0 0 0-1.266.13l-9.94 12.223a.901.901 0 0 0 .131 1.266l2.794 2.271a.901.901 0 0 0 1.267-.13l3.37-4.143c-.025.225-.04.45-.04.683 0 .65.105 1.274.293 1.862l-2.794 3.436c-.63.772-1.76.89-2.533.261l-4.191-3.407a1.798 1.798 0 0 1-.262-2.532L15.48 9.556c.63-.772 1.76-.89 2.533-.262l.699.568 5.396-6.63c.102-.123.217-.22.335-.31l-.4-.323a.901.901 0 0 1 1.135-1.397L28.67 4.04z"
    />
  );
};

CricketPath.propTypes = {
  fill: PropTypes.string,
};

export default CricketPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/sports/cricket.jsx